export default "https://cdn-static.gokick.com/assets/ea2c661fec3366c14365f7d1c68d2a3d0c715dc9/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";